// Mint-KPI · tab Công ty — dữ liệu mẫu theo board (script `Mint-KPI.dc.html`, kỳ Oct/2026). Không tiền, không lương.

export type KpiTab = 'co' | 'dept' | 'staff' | 'mine' | 'close' | 'rules';
export const KPI_TABS: { key: KpiTab; label: string }[] = [
  { key: 'co', label: 'Công ty' },
  { key: 'dept', label: 'Theo phòng' },
  { key: 'staff', label: 'Theo người' },
  { key: 'mine', label: 'KPI của tôi' },
  { key: 'close', label: 'Chốt kỳ' },
  { key: 'rules', label: 'Quy tắc KPI' },
];

export type Grade = 'A' | 'B' | 'C' | 'D';
export const KPI_GRADES: Record<Grade, number> = { A: 0, B: 16, C: 15, D: 0 };
export const KPI_GRADE_NOTE = 'ngưỡng hạng tạm 90 / 75 / 60 · chờ anh chốt';
export const KPI_UNSCORED = { who: '[SALE-PRC] TRANGHDD', n: 1, label: 'Chưa có bộ chỉ số' };

export const KPI_STAFF = { scored: 31, total: 32, note: 'TRANGHDD chưa có bộ chỉ số' };
export const KPI_AVG = 75.9;
export const KPI_DEPTS: { k: string; avg: number }[] = [
  { k: 'Kinh doanh', avg: 76.0 },
  { k: 'DVKH', avg: 77.6 },
  { k: 'Đặt chỗ', avg: 76.2 },
  { k: 'Vận hành', avg: 74.2 },
  { k: 'Điều độ', avg: 75.3 },
  { k: 'Tài xế', avg: 75.0 },
  { k: 'Kế toán', avg: 77.8 },
];

export type Gauge = { k: string; label: string; pct: number; sub: string; tone: 'ok' | 'blue' | 'amber' };
export const KPI_GAUGES: Gauge[] = [
  { k: 'A_APPROVE', label: 'HĐ đầu vào đã duyệt', pct: 95.5, sub: '17.220 / 18.022', tone: 'ok' },
  { k: 'DDL', label: 'giao chứng từ đúng hạn', pct: 93.3, sub: 'OnTime 97 / 104', tone: 'blue' },
  { k: 'B_CFM', label: 'BK Confirmed trước Close Doc', pct: 91.4, sub: 'Mẫu', tone: 'blue' },
  { k: 'C_SI', label: 'SI tạo trước Close Doc', pct: 87.9, sub: 'Mẫu', tone: 'amber' },
];

export type KpiRow = { k: string; label: string; dept: string; actual: string; target: string; kind: 'Thực tế' | 'Mẫu'; src: string };
export const KPI_ROWS: KpiRow[] = [
  { k: 'C_VOL', label: 'Số job xử lý (toàn công ty)', dept: 'CS', actual: '501', target: 'chưa đặt', kind: 'Thực tế', src: 'Oct/2026' },
  { k: 'D_TRIPS', label: 'Số chuyến điều phối', dept: 'DISPATCH', actual: '224', target: 'chưa đặt', kind: 'Thực tế', src: 'Oct/2026 · TRF' },
  { k: 'A_APPROVE', label: 'HĐ đầu vào đã duyệt', dept: 'ACC', actual: '95,5%', target: 'chưa đặt', kind: 'Thực tế', src: '2026 · 17.220 / 18.022' },
  { k: 'DDL', label: 'giao chứng từ đúng hạn', dept: 'OPS', actual: '93,3%', target: 'chưa đặt', kind: 'Thực tế', src: 'KPIResult OnTime 97 / 104' },
  { k: 'B_CFM', label: 'BK Confirmed trước Close Doc', dept: 'BOOKING', actual: '91,4%', target: 'chưa đặt', kind: 'Mẫu', src: 'TblKPIStamp' },
  { k: 'C_SI', label: 'SI tạo trước Close Doc', dept: 'CS', actual: '87,9%', target: 'chưa đặt', kind: 'Mẫu', src: 'TblKPIStamp' },
];

export const fmtVi = (v: number, d = 1) => v.toFixed(d).replace('.', ',');

/** Điểm cung gauge nửa vòng: bán kính r, tâm (cx, cy), phần trăm 0–100 → đường path SVG. */
export function gaugeArc(cx: number, cy: number, r: number, pct: number): string {
  const a = Math.PI * (1 - Math.max(0, Math.min(100, pct)) / 100);
  const x = cx + r * Math.cos(a);
  const y = cy - r * Math.sin(a);
  return `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${x.toFixed(2)} ${y.toFixed(2)}`;
}

/** Phần trăm hạng trên tổng người đã có điểm (làm tròn, như board). */
export function gradeShare(g: Record<Grade, number>): Record<Grade, number> {
  const sum = g.A + g.B + g.C + g.D;
  const f = (n: number) => (sum ? Math.round((n / sum) * 100) : 0);
  return { A: f(g.A), B: f(g.B), C: f(g.C), D: f(g.D) };
}
